import { motion } from 'framer-motion'

import { motionFadeIn } from '@apps-common/config/motion-variants'

interface IProps {
  key: string
  hideStatus?: boolean
}

export const HistorySkeletonCard: React.FC<IProps> = ({ key, hideStatus }) => (
  <motion.div
    key={`history-skeleton-card-${key}`}
    {...motionFadeIn(0.3)}
    className='relative overflow-hidden w-full bg-surface border border-border rounded-[24px] p-4 flex items-end justify-between animate-pulse'
  >
    <div className='grow flex flex-col gap-[10px] items-start justify-between'>
      <div className='w-[60%] h-[15px] rounded bg-surface-2' />
      <div className='w-full flex items-center justify-start gap-[8px]'>
        <div className='w-[26px] h-[26px] rounded-full bg-surface-2' />
        <div className='w-[40%] h-[18px] rounded bg-surface-2' />
      </div>
    </div>
    {!hideStatus && (
      <div className='absolute bottom-0 right-0 m-[7px] px-[22px] w-[50px] h-[50px] rounded-[20px] bg-surface-2 gap-[10px]' />
    )}
  </motion.div>
)
